module.exports = __webpack_public_path__ + "img/undeclared_cargo_illustration.60416b57.jpg";